import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useTimezone } from '../timezone';
import {
  ACTIVITY_SUMMARY_MOCK_PARAM,
  areActivitySummaryMocksAllowed,
  getVolunteerActivitySummaryMock,
} from '../../components/activitySummary/mocks/volunteerActivitySummaryFixtures';
import { GetVolunteerActivitySummaryResponse } from '../../components/activitySummary/types';

export const VOLUNTEER_ACTIVITY_SUMMARY_QUERY_KEY = ['RedVelvetApi', 'getVolunteerActivitySummary'];

/**
 * The caller's own Volunteer summary. Serves mock fixtures for now (cce-8086); cce-8087 swaps the
 * queryFn for the GetVolunteerActivitySummary call and keeps the same response shape and key.
 * Mock data loads only on local, dev, alpha, every ITL target, and personal stacks (any origin
 * not in config.tsx); beta and prod never get it, so the panel stays hidden there.
 */
export function useVolunteerActivitySummary() {
  const timeZone = useTimezone();
  const [searchParams] = useSearchParams();
  const mockFixture = searchParams.get(ACTIVITY_SUMMARY_MOCK_PARAM);

  return useQuery<GetVolunteerActivitySummaryResponse>({
    queryKey: [...VOLUNTEER_ACTIVITY_SUMMARY_QUERY_KEY, { timeZone, mockFixture }],
    queryFn: async () => getVolunteerActivitySummaryMock(mockFixture),
    enabled: areActivitySummaryMocksAllowed(),
    // The panel hides on failure and never shows an error, so retrying only delays that.
    retry: false,
  });
}
